import { Select } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDebouncedCallback } from "../../hooks/useDebouncedCallback";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import { useTranslation } from "react-i18next";

export default function SelectEmpresaUnidade({ empresaId, onChange, params, value, ...props }) {
  const { t } = useTranslation();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [options, setOptions] = useState([]);

  const fetchSearch = (search) => {
    setLoadingSearch(true);
    unwrapAxiosPromise(axios.get(`/empresas/${empresaId}/unidades`, { params: { search, ...params } }))
      .then((data) => {
        setOptions(data);
      })
      .finally(() => setLoadingSearch(false));
  };

  const handleChange = (id) => {
    // Quando for limpar, o id será undefined → passamos null
    onChange(id === undefined ? null : id);
  };

  const handleSearch = useDebouncedCallback(
    500,
    (search) => {
      fetchSearch(search);
    },
    [],
  );

  useEffect(() => {
    fetchSearch();
  }, []);

  return (
    <Select
      allowClear
      placeholder={t("Todas as unidades")}
      filterOption={false}
      loading={loadingSearch}
      onChange={handleChange}
      onSearch={handleSearch}
      showSearch
      value={value ?? undefined}
      {...props}
    >
      {options.map((option) => (
        <Select.Option key={option.id} value={option.id}>
          {option.apelido}
        </Select.Option>
      ))}
    </Select>
  );
}

SelectEmpresaUnidade.propTypes = {
  empresaId: PropTypes.number,
  onChange: PropTypes.func,
  params: PropTypes.any,
  value: PropTypes.number,
};
